import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { axios } from '@utils/lib';
import { Enums, Paths, Value } from '@utils/constants';

export const getTags = createAsyncThunk(
  'api/getTags',
  async (_query, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<string[]>>(
        Enums.HTTP_METHOD.GET,
        Paths.TAG,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getAttribute = createAsyncThunk(
  'api/getAttribute',
  async (query: IGetAttribute, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const formData = new FormData();
      formData.append('file', query.file!);
      const { data } = await axios.request<IDataRes<IFaceAttributeRes>>(
        Enums.HTTP_METHOD.POST,
        Paths.ATTRIBUTE,
        formData,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getMemberList = createAsyncThunk(
  'api/getMemberList',
  async (query: IMemberListQuery, { rejectWithValue, dispatch }) => {
    const searchQuery: Record<string, string> = {
      page: query.page ?? Value.TABLE_PAGE_INIT,
      pageSize: query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'id:desc',
    };
    if (query.displayName) searchQuery.displayName = query.displayName;

    const params = new URLSearchParams(searchQuery).toString();
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IListRes<IMemberListRes>>(
        Enums.HTTP_METHOD.GET,
        Paths.MEMBER + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getMemberDetail = createAsyncThunk(
  'api/getMemberDetail',
  async (query: IMemberDetailQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<IMemberListRes>>(
        Enums.HTTP_METHOD.GET,
        Paths.UPDATE_MEMBER.replace(':id', String(query.id)),
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const memberRegisterAsync = createAsyncThunk(
  'api/memberRegisterAsync',
  async (query: IMemberRegisterQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const formData = new FormData();
      formData.append('data', JSON.stringify(query.data));
      formData.append('file', query.files!);
      const { data } = await axios.request<IMemberRegisterRes>(
        Enums.HTTP_METHOD.POST,
        Paths.MEMBER,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const memberUpdateAsync = createAsyncThunk(
  'api/memberUpdateAsync',
  async (query: IMemberUpdateQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<IMemberRegisterRes>>(
        Enums.HTTP_METHOD.PATCH,
        Paths.UPDATE_MEMBER.replace(':id', String(query.memberId)),
        query.data,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const deleteMemberAsync = createAsyncThunk(
  'api/deleteMemberAsync',
  async (query: IMemberDetailQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<IDeleteMemberRes>>(
        Enums.HTTP_METHOD.DELETE,
        Paths.UPDATE_MEMBER.replace(':id', String(query.id)),
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
